import React from 'react';
import PropTypes from 'prop-types';
import { allowedMessageProps } from './_allowedPropTypes';
import MessageText from './_MessageText';

const MessageArea = ({ message }) => {
  let areaContent = null;
  const wrapClasses = ['area-system-message-single'];

  if (message) {
    const { message: text, mood } = message;
    wrapClasses.push('has-content');
    areaContent = <MessageText text={text} mood={mood} />;
  }

  return (
    <div
      className={wrapClasses.join(' ')}
      aria-live='polite'
      aria-relevant='additions removals'
    >
      {areaContent}
    </div>
  );
};

MessageArea.propTypes = { message: PropTypes.shape(allowedMessageProps) };

export default MessageArea;